jQuery(function($) {
  $(window).on('load resize', function(){
    if (window.innerWidth >= 1024) {
      var collage = $('.collage').height();
      $('.collage').css('margin-bottom', (collage - 250) + 'px');
    }
    if (window.innerWidth < 1024) {
      $('.collage').css('margin-bottom', '20px');
    }
  });
});
